import { object, string, array, number, boolean } from 'yup';

export const placeholderReceivingValidation = () =>
  object().shape({
    orderItems: array().of(
      object().shape({
        productId: string().required('Product ID required'),
        quantity: number().required('Quantity required').min(0, 'Must be at least 0'),
        missing: boolean().required('Missing required'),
      }),
    ),
  });
